<style scoped>
	.allorderbill-total-p-s {
		margin-left: 191px;
		font-size: 1em;
	}
	.allorderbill-total-p strong {
		font-size: 0.8em;
	}
</style>
<template>
<div class="edi-allorderbill">
	<navbar title="供货商对账单"></navbar>
	<div class="common-scroll" id="common-scroll" @scroll="refresh" style="bottom:0">
		<div class="filter">
			<input type="text" v-model="keyword" class="ui-search-input"
				:class="{'ui-search-input2':filterShow, 'ui-search-input1': !filterShow}"
				@keyup.enter="enterSearch"
			/>
			<a class="ui-filter-icon" @click="move"></a>
		</div>
		<div class="container">
			<ul class="ui-listview" style="padding-bottom: 0">
				<li v-for="returnBill in returnBills">
					<router-link :to="{ path: '/supplier-account-check-detail-bill',
						query: { bill_id: returnBill.id, trans_bill_id: returnBill.trans_bill_id }}"
					>
						<p class="allorderbill-list-p">{{returnBill.to_organ_name || ''}}
						<span v-if="returnBill.bill_state == 0" class="grey-font"><i></i>未对账</span>
						<span v-if="returnBill.bill_state == 1" class="red-font"><i></i>已对账</span>
						</p>
						<ul class="ui-detail-listview ui-detail-listviews">
							<li>单号：{{returnBill.trans_bill_no}}</li>
							<li>业务日期：{{dateCut(returnBill.from_date)}}</li>
						</ul>
						<p class="allorderbill-total-p allorderbill-total-p-s"><strong>含税金额：{{returnBill.include_tax_sum_money}}</strong></p>
					</router-link>
				</li>
			</ul>
		</div>
		<refresh v-show="!show" :cls="cls" :font="font"></refresh>
		<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
	</div>
	<loading v-show="loading"></loading>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<bill-filter ref="billFilterOpen" v-on:confirm="backValue"
		:filterBillState="queryData.bill_state" :filterBillFont="queryData.bill_font"
		:filterStarDate="queryData.start_date" :filterEndDate="queryData.end_date"
	></bill-filter>
</div>
</template>
<script>
// import ReturnBillFilter from '../components/AccountCheckBillFilter'
import BillFilter from '../components/SupplierAccountCheckBillFilter'
import Loading from '../components/loading'
import Tips from '../components/Tips'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			filterShow: true,
			show: true,
			cls: '',
			font: '',
			midware: true,
			icon: '',
			midFont: '',
			loading: true,
			tips: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			queryData: this.$route.query,
			returnBills: [],
			// bill_type: 2,
			keyword: '',
			length: 10,
			start: 0,
			filterData: {},
			prevLength: 0,
			back_state: '0,1',
			bill_state: '',
			back_state_font: '',
			start_date: '',
			end_date: '',
			store: GlobalStore,
			goodsTotalInfo: {},
			billFilterData: {}
		}
	},
	components: {
		'bill-filter': BillFilter,
		'loading': Loading,
		'tips': Tips,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'navbar': NavBar
	},
	created () {
		if (this.queryData.filterShow === false) {
			this.filterShow = false
		}
		// 如果有筛选条件,按照筛选条件查询 shang 2017/10/19
		this.billFilterData = this.store.billFilterData
		if (this.billFilterData.filterFlag) {
			this.queryData.bill_state = this.billFilterData.filterBillState
			this.queryData.bill_font = this.billFilterData.filterBillStateFont
			this.queryData.start_date = this.billFilterData.filterStartDate
			this.queryData.end_date = this.billFilterData.filterEndDate
			this.start_date = this.billFilterData.filterStartDate
			this.end_date = this.billFilterData.filterEndDate
		}
		this.loading = true
		this.bill_state = this.queryData.bill_state
		this.bill_state_font = this.queryData.bill_font
		var billState = this.bill_state
		var keyWord = this.keyword
		var startDate = this.start_date
		var endDate = this.end_date
		this.filterData = {
			bill_state: billState,
			start_date: startDate,
			end_date: endDate,
			keyword: keyWord,
			length: 10,
			start: 0
		}

		this.$http.post('/cldEdi/reconciliation/list', this.filterData).then((response) => {
			this.loading = false
			this.returnBills = response.body.data
			if (this.returnBills === null) {
				this.midware = true
				this.icon = 'middle-empty'
				this.midFont = '没有数据'
				return false
			}
			this.prevLength = this.returnBills.length
		}, (response) => {
			this.loading = false
			this.midware = true
			this.icon = 'middle-net'
			this.midFont = '服务中断，稍后请重试！'
		})
	},
	methods: {
		move () {
			var obj = {
				back_state: this.bill_state,
				back_state_font: this.bill_state_font
			}
			this.$refs.billFilterOpen.move(obj)
		},
		dateCut (val) {
			var arr = val.split(' ')
			return arr[0]
		},
		refresh () {
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			if (marginBot <= 1) {
				this.show = false
				if (this.prevLength < 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.show = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var billState = this.bill_state
				var keyWord = this.keyword
				var startDate = this.start_date
				var endDate = this.end_date
				this.filterData = {
					bill_state: billState,
					start_date: startDate,
					end_date: endDate,
					keyword: keyWord,
					length: 10,
					start: start
				}
				this.$http.post('/cldEdi/reconciliation/list', this.filterData).then((response) => {
					var data = response.body.data
					this.show = true
					this.prevLength = data.length
					this.returnBills = this.returnBills.concat(data)
				}, (response) => {
					this.loading = false
					this.midware = true
					this.icon = 'middle-net'
					this.midFont = '服务中断，稍后请重试！'
				})
			}
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		// 修复筛选无效 shang 2017/10/19
		backValue (msg) {
			window.console.log(msg)
			this.bill_state = msg.bill_state
			this.bill_state_font = msg.bill_state_font
			this.start_date = msg.start_date
			this.end_date = msg.end_date
			this.search()
		},
		search () {
			this.loading = true
			this.midware = false
			var billState = this.bill_state
			var startDate = this.start_date
			var endDate = this.end_date
			var sortMethod = this.sort
			var keyWord = this.keyword
			this.filterData = {
				bill_state: billState,
				start_date: startDate,
				end_date: endDate,
				keyword: keyWord,
				sort: sortMethod,
				length: 10,
				start: 0
			}
			this.$http.post('/cldEdi/reconciliation/list', this.filterData).then((response) => {
				this.loading = false
				this.returnBills = response.body.data
				if (this.returnBills === null) {
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		// 搜索栏回车搜索,实现明细退回单据主页面,依然存在搜索条件 shang 2017/10/19
		enterSearch () {
			this.loading = true
			this.midware = false
			var billState = this.queryData.bill_state
			var startDate = this.start_date
			var endDate = this.end_date
			var sortMethod = this.queryData.sort
			var keyWord = this.keyword
			this.filterData = {
				bill_state: billState,
				start_date: startDate,
				end_date: endDate,
				keyword: keyWord,
				sort: sortMethod,
				length: 10,
				start: 0
			}
			this.$http.post('/cldEdi/reconciliation/list', this.filterData).then((response) => {
				this.loading = false
				this.returnBills = response.body.data
				if (this.returnBills === null) {
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// SupplierAccountCheckBill.vue?cad78a60